
/***************************************
 * DATA LAYER HELPER WITH UTM CONTEXT
 ***************************************/
window.pushGTMEvent = function (eventName, params = {}) {
  window.dataLayer = window.dataLayer || [];

  function getCookie(name) {
    const match = document.cookie
      .split("; ")
      .find(row => row.startsWith(name + "="));
    return match ? decodeURIComponent(match.split("=")[1]) : null;
  }

  const utmContext = {
    utm_source: getCookie("utm_source"),
    utm_medium: getCookie("utm_medium"),
    utm_campaign: getCookie("utm_campaign"),
    utm_term: getCookie("utm_term"),
    utm_content: getCookie("utm_content")
  };

  Object.keys(utmContext).forEach(
    key => utmContext[key] === null && delete utmContext[key]
  );

  window.dataLayer.push({
    event: eventName,
    ...utmContext,
    ...params
  });
};


/***************************************
 * ADD TO CART EVENT
 ***************************************/
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".addToCart");
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const name = btn.dataset.name;
  const brand = btn.dataset.brand || "";
  const rawPrice = btn.dataset.price;

  const price = rawPrice ? Number(rawPrice.replace(/,/g, "")) : null;

  if (!variantId || !name || !price) {
    console.warn("GTM add_to_cart skipped due to missing data", {
      variantId,
      name,
      brand,
      price
    });
    return;
  }

  const qtyInput =
    btn.closest("form")?.querySelector('input[name="quantity"]') ||
    document.querySelector('input[name="quantity"]');

  const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  pushGTMEvent("add_to_cart", {
    currency: "INR",
    value: price * quantity,
    ecommerce: {
      items: [
        {
          item_id: variantId,
          item_name: name,
          item_brand: brand,
          price: price,
          quantity: quantity
        }
      ]
    }
  });
});


/***************************************
 * BUY NOW → BEGIN CHECKOUT
 ***************************************/
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".buy-now");
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const name = btn.dataset.name;
  const brand = btn.dataset.brand || "";
  const rawPrice = btn.dataset.price;

  const price = rawPrice ? Number(rawPrice.replace(/,/g, "")) : null;

  if (!variantId || !name || !price) {
    console.warn("GTM begin_checkout skipped due to missing data", {
      variantId,
      name,
      brand,
      price
    });
    return;
  }

  const qtyInput =
    btn.closest("form")?.querySelector('input[name="quantity"]') ||
    document.querySelector('input[name="quantity"]');

  const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  pushGTMEvent("begin_checkout", {
    currency: "INR",
    value: price * quantity,
    ecommerce: {
      items: [
        {
          item_id: variantId,
          item_name: name,
          item_brand: brand,
          price: price,
          quantity: quantity
        }
      ]
    }
  });
});


/***************************************
 * PRODUCT IMAGE CLICK (CUSTOM EVENT)
 ***************************************/
document.addEventListener("click", function (e) {
  const image = e.target.closest(".mainImagefcbox");
  if (!image) return;

  const itemId = image.dataset.itemId;
  const itemName = image.dataset.itemName;
  const itemCategory = image.dataset.itemCategory || "";
  const imagePosition = image.dataset.imagePosition || "";

  if (!itemId || !itemName) return;

  pushGTMEvent("product_image_click", {
    item_id: itemId,
    item_name: itemName,
    item_category: itemCategory,
    image_position: imagePosition
  });
});


/***************************************
 * UTM CAPTURE & COOKIE PERSISTENCE
 ***************************************/
document.addEventListener("DOMContentLoaded", function () {
  const COOKIE_DAYS = 30;

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/`;
  }

  function getCookie(name) {
    const match = document.cookie
      .split("; ")
      .find(row => row.startsWith(name + "="));
    return match ? decodeURIComponent(match.split("=")[1]) : null;
  }

  const utmKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ];

  utmKeys.forEach(key => {
    const value = getParam(key);
    if (value && !getCookie(key)) {
      setCookie(key, value, COOKIE_DAYS);
    }
  });

  const currentUrlInput = document.querySelector(".currentUrl");
  if (currentUrlInput) {
    currentUrlInput.value = window.location.href;
  }

  const utmQuery = utmKeys
    .map(key => {
      const val = getCookie(key);
      return val ? `${key}=${encodeURIComponent(val)}` : null;
    })
    .filter(Boolean)
    .join("&");

  if (!utmQuery) return;

  document.querySelectorAll("a[href]").forEach(link => {
    const href = link.getAttribute("href");

    if (
      !href ||
      href.startsWith("#") ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:") ||
      href.includes("utm_")
    ) return;

    if (href.startsWith("/") || href.startsWith(window.location.origin)) {
      link.setAttribute(
        "href",
        href + (href.includes("?") ? "&" : "?") + utmQuery
      );
    }
  });
});

